import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './ContentRating.module.scss'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import cx from 'classnames'

interface UpvoteProps {
  showTellUsMore: boolean
  setShowTellUsMore: (show: boolean) => void
  extraFeedback: string
  setExtraFeedback: (feedback: string) => void
  onSubmit: (feedback: string) => void
  onClose: () => void
  className?: string
}

export const Upvote = ({
  showTellUsMore,
  setShowTellUsMore,
  extraFeedback,
  setExtraFeedback,
  onSubmit,
  onClose,
  className,
}: UpvoteProps) => {
  return (
    <div className={cx(Styles.root, className, { [Styles.upvoteFeedback]: showTellUsMore })}>
      {showTellUsMore ? (
        <>
          <div className={Styles.closeButton}>
            <IconButton
              aria-label="Back"
              onPress={onClose}
              icon={() => <Close size={16} />}
              variant="tertiary"
              size="sm"
            />
          </div>
          <Text variant="secondary">Thank you for your feedback!</Text>
          <Input
            isTextarea
            rows={3}
            placeholder="Tell us more"
            name="tell-us-more"
            autoFocus
            value={extraFeedback}
            onChange={(e) => setExtraFeedback(e.target.value)}
          />
          <div className={Styles.submitButton}>
            <Button aria-label="Submit" onPress={() => onSubmit(extraFeedback)} size="sm">
              Send Feedback
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={Styles.loadingBar} aria-hidden>
            <div className={Styles.loadingBarFill} />
          </div>
          <Text variant="secondary">Thank you for your feedback.</Text>
          <div className={Styles.buttons}>
            <Button aria-label="Tell us more" onPress={() => setShowTellUsMore(true)} variant="secondary" size="md">
              Tell us more
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
